var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCampIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72.153,
    height: 90.572,
    viewBox: "0 0 72.153 90.572",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_340",
    x: 3.958,
    y: 0,
    width: 64.237,
    height: 52.544,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#b46608",
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_338",
    x: 0,
    y: 27.154,
    width: 72.153,
    height: 38.026,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#b46608",
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_339",
    x: 3.61,
    y: 36.81,
    width: 64.933,
    height: 53.762,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#b46608",
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_145",
    "data-name": "Groupe 145",
    transform: "translate(58 114.93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_144",
    "data-name": "Groupe 144",
    transform: "translate(-45.39 -114.93)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -12.61, 0)",
    filter: "url(#Trac\\xE9_340)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_340-2",
    "data-name": "Trac\\xE9 340",
    d: "M-4.063-95.157a1.8,1.8,0,0,1-2.387-.9l-5.635-12.614A23.671,23.671,0,0,0-24.313-91.386H21.924A23.67,23.67,0,0,0,9.7-108.674L4.06-96.059a1.8,1.8,0,0,1-2.387.9,1.8,1.8,0,0,1-.9-2.386L7.008-111.5a1.81,1.81,0,0,0-1.12-2.492,27.1,27.1,0,0,0-14.166,0A1.812,1.812,0,0,0-9.4-111.5L-3.16-97.543a1.8,1.8,0,0,1-.9,2.386Zm0,0",
    transform: "translate(37.27 114.93)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -12.61, 0)",
    filter: "url(#Trac\\xE9_338)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_338-2",
    "data-name": "Trac\\xE9 338",
    d: "M-49,56.226v1.805a1.807,1.807,0,0,0,1.31,1.737,106.31,106.31,0,0,0,25.766,3.679A106.31,106.31,0,0,0,3.843,59.768a1.807,1.807,0,0,0,1.31-1.737V56.226a1.8,1.8,0,0,0-1.805-1.8H-47.195A1.8,1.8,0,0,0-49,56.226Zm0,0",
    transform: "translate(58 -27.27)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -12.61, 0)",
    filter: "url(#Trac\\xE9_339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_339-2",
    "data-name": "Trac\\xE9 339",
    d: "M18.643,121.229a1.8,1.8,0,0,0,1.805-1.805v-4.785c-2.564.606-6.422,1.415-10.918,2.041A12.614,12.614,0,0,1-3.018,128.45a12.614,12.614,0,0,1-12.548-11.77c-4.5-.626-8.355-1.436-10.918-2.041v4.785a1.8,1.8,0,0,0,1.805,1.805h2.56a19.506,19.506,0,0,0,1.777,4.252l-1.821,1.821a1.8,1.8,0,0,0,0,2.552l5.1,5.105a1.806,1.806,0,0,0,2.553,0l1.821-1.822a19.5,19.5,0,0,0,4.252,1.777v2.68a1.8,1.8,0,0,0,1.8,1.805H.592A1.8,1.8,0,0,0,2.4,137.6v-2.68a19.453,19.453,0,0,0,4.252-1.777L8.47,134.96a1.805,1.805,0,0,0,2.552,0l5.105-5.105a1.8,1.8,0,0,0,0-2.552l-1.821-1.821a19.505,19.505,0,0,0,1.777-4.252Zm0,0",
    transform: "translate(39.09 -77.83)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampIcon);
export default __webpack_public_path__ + "static/media/camp-icon.4af2908e3402dae3a1613ac9e4c16639.svg";
export { ForwardRef as ReactComponent };